import React from "react";

export const isCheckedAddress = ({ address, institution, principal, type }) => {
  let defaultProjection = "";
  if (type === typeAddress.postal) {
    defaultProjection = "defaultAddress";
  } else {
    defaultProjection = "defaultLocation";
  }

  if (institution !== null) {
    return institution[defaultProjection] === address._id;
  }

  if (principal !== null) {
    return principal.defaultAddress === address._id;
  }
};

export const typeAddress = {
  maps: "maps",
  postal: "postal",
};

/**
 * Texte affiché quand /addresses/exist renvoie des doublons (ex. modal InstitutionNewAddress).
 * Les adresses postales n’ont pas location/maps ; les lieux maps peuvent n’avoir que lat/lng.
 */
export const renderDuplicateAddressHint = address => {
  if (address == null) {
    return "—";
  }

  if (address.type === typeAddress.maps) {
    const loc = address.location != null ? String(address.location).trim() : "";
    const maps = address.maps != null ? String(address.maps).trim() : "";
    if (loc || maps) {
      return (
        <>
          {loc || <cite>Lieu (institution) non renseigné</cite>}
          <br />
          <b>{maps || <cite>Adresse réelle non renseignée</cite>}</b>
        </>
      );
    }
    const title = address.description || address.name || "";
    const lat = address.latitude;
    const lng = address.longitude;
    const coords =
      lat != null && lng != null
        ? `${Number(lat).toFixed(5)}, ${Number(lng).toFixed(5)}`
        : null;
    return (
      <>
        {title ? (
          <>
            <b>{title}</b>
            <br />
          </>
        ) : null}
        {coords ? (
          <span>Coordonnées : {coords}</span>
        ) : (
          <cite>Adresse sans libellé enregistré</cite>
        )}
      </>
    );
  }

  // postal (schéma par défaut) ou type absent — aligné sur renderAdress (sans mandant / partage)
  const hasPostal =
    (address?.description && String(address.description).trim()) ||
    (address?.beneficiary && String(address.beneficiary).trim()) ||
    (address?.street && String(address.street).trim()) ||
    (address?.zip && String(address.zip).trim()) ||
    (address?.city && String(address.city).trim());

  if (!hasPostal) {
    return <cite>Adresse sans détail enregistré</cite>;
  }

  return (
    <>
      {address?.description && <b>{address.description}</b>}
      <br />
      <span>
        {address?.beneficiary} {address?.person && `, ${address.person}`}
        <br />
        {address?.street} {address?.number}
        {address?.complement && ` - ${address.complement}`} - {address?.zip}{" "}
        {address?.city}
      </span>
    </>
  );
};

export const renderAdress = (adress, isDefault = false, fromInstitution) => {
  if (adress === null) {
    return "- ";
  }

  if (adress?.type === typeAddress.postal) {
    return (
      <>
        {adress?.description && <b>{adress.description}</b>}
        {isDefault && <cite> - Par défaut</cite>}
        {adress.principal !== null && adress.principal !== undefined ? (
          <cite> - Mandant {adress.principal?.name}</cite>
        ) : null}
        {fromInstitution?._id !== adress?.institution?._id ? (
          <cite> - Institution {adress.institution?.name}</cite>
        ) : null}
        {adress?.external === true && (
          <cite> - *Institution externe, facture par courrier postal</cite>
        )}
        <br />
        <span>
          {adress?.beneficiary} {adress?.person && `, ${adress.person}`}
          <br />
          {adress?.street} {adress?.number}
          {adress?.complement && ` - ${adress.complement}`} - {adress?.zip}{" "}
          {adress?.city}
        </span>
      </>
    );
  }

  if (adress?.type === typeAddress.maps) {
    return (
      <>
        {adress.location} {isDefault && <cite> - Par défaut</cite>} <br />
        <b>{adress.maps}</b>
      </>
    );
  }
};

export const renderStringAddress = (address, isDefault = false) => {
  if (!address) {
    return "- ";
  }

  let addressString = "";

  if (address.description) {
    addressString += `${address.description}`;
  }

  if (isDefault) {
    addressString += addressString ? " - Par défaut" : "Par défaut";
  }

  if (address.external === true) {
    addressString += addressString
      ? " - *Institution externe, facture par courrier postal"
      : "*Institution externe, facture par courrier postal";
  }

  addressString += addressString ? "\n" : "";

  let details = `${address.beneficiary || ""}`;
  if (address.person) {
    details += `, ${address.person}`;
  }

  details += `\n${address.street || ""} ${address.number || ""}`;
  if (address.complement) {
    details += ` - ${address.complement}`;
  }
  details += ` - ${address.zip || ""} ${address.city || ""}`;

  addressString += details;

  return addressString;
};
